import React, { useEffect,useRef,memo } from 'react'
import { Box } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';


const columns = [
    { id: 'timestamp', label: 'Timestamp'},
    { id: 'user_email_address', label: 'Username'},
    { id: 'genset_serial_number', label: 'Genset Serial Number'},
    { id: 'change_log_type', label: 'Log Type'},
    { id: 'change_log_subtype', label: 'Log Sub Type'},
    { id: 'log_description', label: 'Description'}
];

const ChangeLogSocket = memo(({changeLogData}) => {

    const tableContainerRef = useRef(null);

    useEffect(() => {
        if(tableContainerRef.current){
            tableContainerRef.current.scrollTop = 0;
        }
    }, [changeLogData]);
    
    return (
        <>
            <Box>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>  
                    <div className='boxedContainer' ref={tableContainerRef} style={{maxHeight:'300px',overflowY: 'auto'}}>
                        <Table 
                        sx={{
                            '& .MuiTableCell-sizeMedium': {
                              paddingTop: '6px',
                              paddingBottom: '6px',
                            },
                        }}
                        stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                        //key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth,fontSize:'0.75rem' }}
                                        >
                                        { column.label }
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { changeLogData?.length > 0 ? changeLogData?.map((row,index) => {
                                    let rowData = row;
                                    return (
                                        <>
                                            <TableRow style={ !index ? { background : "#FFE5A4" }:{ background : "#FFFFFF" }} role="checkbox" tabIndex={-1} key={index} sx={{ '& > *': { borderBottom: 'unset' } }}>
                                                {columns.map((column) => {
                                                    const value = rowData[column.id];
                                                    return (
                                                        <TableCell style={{fontSize:'0.75rem'}} key={column.id} align={column.align}>
                                                            { column.format && typeof value === 'number' ? column.format(value) :  value }
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </>
                                    );
                                }) : <TableRow><TableCell  align="center" style={{fontSize:'0.75rem',height: '112px',fontWeight:'500'}} colSpan={6}> No Data Available. </TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </div>  
                </Paper>
            </Box>  
        </>
    )
});

export default ChangeLogSocket